import { apolloClient } from "@/vue-apollo";
import Vue from "vue";

function getGraphQLErrorMessage(error) {
  if (!error) return "";

  if (Array.isArray(error?.graphQLErrors) && error.graphQLErrors.length) {
    return error.graphQLErrors
      .map((item) => String(item?.message || "").trim())
      .filter(Boolean)
      .join(" | ");
  }

  const networkErrors = error?.networkError?.result?.errors;
  if (Array.isArray(networkErrors) && networkErrors.length) {
    return networkErrors
      .map((item) => String(item?.message || "").trim())
      .filter(Boolean)
      .join(" | ");
  }

  const fallback = String(error?.message || "").trim();
  return fallback;
}

function toast(txt, type) {
  if (txt === "") return;
  Vue.$toast.open({
    message: txt,
    type: type ? "success" : "warning",
    duration: 5000,
    position: "top-right",
  });
}

/**
 * Ejecuta una query GraphQL
 * @param {Object} query - La query de GraphQL
 * @param {Object} variables - Variables para la query
 * @param {Boolean} networkOnly - Si es `true`, no utiliza la cache (network-only) default false
 * @param {String} succ - Mensaje de exito
 * @param {String} err - Mensaje de error
 * @returns {Promise} - Retorna el resultado de la query
 */
export function exQue(
  query,
  variables,
  networkOnly = false,
  succ = "",
  err = ""
) {
  const dataProp = query.definitions[0].name.value;
  return apolloClient
    .query({
      query,
      variables,
      fetchPolicy: networkOnly ? "network-only" : "cache-first",
    })
    .then(({ data, loading, error }) => {
      if (error && error.length) {
        throw new Error(error);
      }
      if (!loading) {
        toast(succ, true);
        return data[dataProp];
      }

      return null;
    })
    .catch((error) => {
      toast(err, false);
      console.error("Error ejecutando query:", error);
      throw error;
    });
}

/**
 * Opciones de exMut para una mutación que devuelve objetos con `id`: Apollo los normaliza y
 * las queries cache-first ven el cambio. Sin esto aplica el no-cache por defecto de vue-apollo.js.
 */
export const MUTACION_CON_CACHE = { fetchPolicy: undefined };

/**
 * Ejecuta una mutation GraphQL
 * @param {Object} mutation - La mutation de GraphQL
 * @param {Object} variables - Variables para la mutation
 * @param {String} succ - Mensaje de exito
 * @param {String} err - Mensaje de error
 * @param {Object} options - Opciones extra para apolloClient.mutate (p. ej. MUTACION_CON_CACHE)
 * @returns {Promise} - Retorna el resultado de la mutation
 */
export function exMut(mutation, variables, succ = "", err = "", options = {}) {
  const dataProp = mutation.definitions[0].name.value;
  return apolloClient
    .mutate({
      mutation,
      variables,
      ...options,
    })
    .then((response) => {
      // Verificar que response exista
      if (!response) {
        throw new Error("La respuesta de la mutación es indefinida");
      }

      const { data, errors } = response;

      if (errors && errors.length) {
        throw new Error(
          errors
            .map((item) => String(item?.message || "").trim())
            .filter(Boolean)
            .join(" | "),
        );
      }

      if (succ) toast(succ, true);
      return data[dataProp];
    })
    .catch((error) => {
      const backendMessage = getGraphQLErrorMessage(error);
      const finalMessage = backendMessage || err;
      if (finalMessage) toast(finalMessage, false);
      console.error("Error ejecutando mutation:", error);
      return null;
    });
}
